import actions from './constants';

export const fetchDictionaryMarkdownSuccess = (category, code, result) => ({
  category,
  code,
  result,
  type: actions.FETCH_DICTIONARY_MARKDOWN_SUCCESS,
});

export const fetchDictionaryMarkdownError = (category, code, error) => ({
  category,
  code,
  error,
  type: actions.FETCH_DICTIONARY_MARKDOWN_ERROR,
});

export const closeDictionaryMarkdown = ({ category, code }) => ({
  category,
  code,
  type: actions.CLOSE_DICTIONARY_MARKDOWN,
});
